// Shared by the server HTML and interactive page to keep search copy and visible content aligned.
module.exports = {
  "title": "Coffee Cost Per Cup Calculator | Bean Pigeon",
  "description": "Calculate coffee cost per cup and monthly bean spend from bag price, size, and dose. See servings per 12 oz bag, worked examples, and the formula.",
  "h1": "Coffee Cost Per Cup Calculator",
  "intro": "Calculate the bean cost of each brew, how many servings a bag makes, and your estimated monthly spend. Use the same dose to compare different bags fairly.",
  "guide": {
    "title": "How to calculate coffee cost per cup",
    "paragraphs": [
      "Coffee cost per cup depends on three things: the price of the bag, the amount of coffee in the bag, and how many grams you use for each brew. Comparing bag price alone can be misleading when bag sizes or brew doses differ.",
      "Formula: cost per brew = bag price × coffee dose in grams ÷ bag weight in grams. Convert ounces to grams by multiplying by 28.3495. For a $20 bag weighing 12 oz, a dose of 18 g costs $20 × 18 ÷ 340.194 = about $1.06 per brew.",
      "Use the same dose when comparing two coffees. A more expensive bag can sometimes have a similar cost per cup if it is larger, while a cheaper small bag can cost more per serving than it first appears.",
      "A serving here means one brew using your chosen dose, not a fixed 6 oz or 8 oz drinking cup. An 18 g espresso dose and an 18 g filter-coffee dose have the same bean cost even though their drink sizes differ. Larger mugs or multi-cup batches may use more coffee."
    ],
    "examples": [
      "$18 for 12 oz at 18 g per brew: about $0.95 per cup",
      "$20 for 12 oz at 18 g per brew: about $1.06 per cup",
      "$24 for 12 oz at 18 g per brew: about $1.27 per cup",
      "$20 for 12 oz at 18 g per brew, twice daily: about $63.49 per 30-day month"
    ]
  },
  "faq": [
    [
      "How do you calculate coffee cost per cup?",
      "Divide the total grams in the bag by the grams of coffee used per brew to estimate the number of servings, then divide the bag price by that serving count."
    ],
    [
      "How many cups are in a 12 oz bag of coffee?",
      "A 12 oz bag is about 340 grams. At 18 grams of coffee per brew, that works out to about 19 servings. At 15 grams per brew, it is about 23 servings."
    ],
    [
      "What does the coffee cost estimate include?",
      "The estimate covers beans only. Add milk, filters, water, electricity, shipping, and equipment separately for a full home-brewing budget. Servings are theoretical: grinder retention, dialing-in waste, and spills reduce the number you actually make."
    ],
    [
      "Should I compare coffee by bag price or price per cup?",
      "Price per cup is usually more useful because it normalizes different bag sizes and brew doses."
    ],
    [
      "How many brews does a 250 g or 1 kg bag make?",
      "Divide bag weight by your dose. At 18 g per brew, a 250 g bag yields about 13.9 brews, a 12 oz bag about 18.9, and a 1 kg bag about 55.6. These are estimates before waste."
    ]
  ],
  "relatedLinks": [
    {
      "href": "/coffee/data/independent-coffee-price-index",
      "label": "Independent Coffee Price Index"
    },
    {
      "href": "/coffee/collections/best-coffee-beans-under-20",
      "label": "Coffee Beans Under $20"
    },
    {
      "href": "/coffee/collections/best-coffee-beans",
      "label": "Browse Best Coffee Beans"
    }
  ]
};
